// src/extenders/product-media.js
var ProductMedia = class extends HTMLElement {
  constructor() {
    super();
    this.productMediaElement = this;
    this.productMediaSwiperElement = this.productMediaElement.querySelector("swiper-slider");
    this.addClickListener();
  }
  // callback = (mutationList, observer) => {
  //   for (const mutation of mutationList) {
  //     if (mutation.type === "childList") {
  //       if (this.screenWidth > 1028) {
  //         this.removeClickListner()
  //         this.addClickListener()
  //       } else {
  //         this.removeClickListner()
  //       }
  //     }
  //   }
  // }
  addClickListener() {
    const swiperElement = this.productMediaElement.querySelector("swiper-slider");
    const swiperInstance = swiperElement.querySelector(".swiper").swiper;
    swiperElement.addEventListener("click", () => {
      swiperInstance.slideNext();
    });
  }
  removeClickListner() {
    const swiperElement = this.productMediaElement.querySelector("swiper-slider");
    const swiperInstance = swiperElement.querySelector(".swiper").swiper;
    swiperElement.removeEventListener("click", () => {
      swiperInstance.slideNext();
    });
  }
  // replaceLowResImages = debounce(() => {
  //   try {
  //     const newImageElements = this.productMediaSwiperElement.querySelectorAll('.swiper-slide img')
  //     newImageElements?.forEach((imageElement) => {
  //       const newImage = new Image()
  //       const lowResolutionUrl = imageElement.src
  //       const highResolutionImage = lowResolutionUrl.replace('width=500', 'width=1000')
  //       const newSourceSet = `${lowResolutionUrl.replace('width=500', 'width=250')} 250w, ${lowResolutionUrl} 500w, ${lowResolutionUrl.replace('width=500', 'width=1000')} 1000w`
  //       newImage.srcset = newSourceSet
  //       newImage.src = highResolutionImage
  //       newImage.alt = imageElement.alt
  //       newImage.onload = () => {
  //         imageElement.srcset = newImage.srcset
  //         imageElement.src = newImage.src
  //         imageElement.alt = newImage.alt
  //       }
  //     })
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }, 2000)
};
if (customElements.get("product-media") === void 0) {
  customElements.define("product-media", ProductMedia);
}
